/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';
import { map, size, compact, round } from 'lodash';
import { Table } from 'antd';
import { connect } from 'react-redux';
import DateTime from 'components/date-time';


/**
 * Internal dependencies
 */
import { startOperationDetailsModal } from 'state/ui/operation-details-modal/actions';
import { successNotice } from 'state/notices/actions';
import DropdownLink from 'components/dropdown-link';
import { cancelOperation, deleteOperation } from 'state/operations/actions';
import Tag from 'components/tag';

/**
 * Style dependencies
 */
import './styles.scss';

const OperationsListTable = ({ operations, requestItems, requesting, ...props }) => {
    const dataSource = map(operations, (r) => {
        return r;
    });

    const columns = [
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            render: (status) => {
                return <Tag className={status}>{status}</Tag>;
            },
        },
        {
            title: 'Created',
            key: 'created_at',
            dataIndex: 'created_at',
            render: (created_at) => {
               return <DateTime date={created_at} format='Do MMM, YYYY HH:mm:ss' />;
            },
        },
        {
            title: 'Success',
            key: 'number_success',
            dataIndex: 'number_success',
            render: (numberSuccess) => {
                return numberSuccess;
            },
        },
        {
            title: 'Warnings',
            key: 'number_warnings',
            dataIndex: 'number_warnings',
            render: (numberWarnings) => {
                return 0;
            },
        },
        {
            title: 'Errors',
            key: 'number_errors',
            dataIndex: 'number_errors',
            render: (numberErrors) => {
                return numberErrors;
            },
        },
        {
            title: 'Tries/Pauses',
            key: 'count_pause',
            render: (a) => {
                return <Text size='xsmall'>{a.count_success}/{a.count_pause}</Text>
            },
        },
        {
            title: 'Duration',
            key: 'duration',
            render: ({ duration }) => {
                let t = '';

                if (!duration || duration <= 0) {
                    return <Text size='xsmall'>-</Text>;
                }

                if (duration < 60) {
                    t = `${duration} seconds`;
                } else {
                    t = `${round(duration / 60)} minutes`;
                }

                return <Text size='xsmall'>{t}</Text>;
            },
        },

        {
            title: 'Actions',
            key: 'actions',
            render: (operation) => {
                return (
                    <DropdownLink
                        title='Actions'
                        items={compact([
                            operation.status && {
                                label: 'View Details',
                                key: 'logs',
                                onClick: () => props.startOperationDetailsModal(operation.id),
                            },
                            (operation.status == 'complete' || operation.status == 'cancelled') && {
                                label: 'Delete',
                                key: 'delete',
                                onClick: async () => {
                                    try {
                                        await props.deleteOperation(operation.id);
                                        props.successNotice('Sync removed.')
                                        requestItems();
                                    } catch (error) { }
                                },
                            },
                            (operation.status == 'pending' || operation.status == 'processing') && {
                                label: 'Cancel',
                                key: 'cancel',
                                onClick: async () => {
                                    try {
                                        await props.cancelOperation(operation.id);
                                        props.successNotice('Sync cancelled.')
                                        requestItems();
                                    } catch (error) {}
                                },
                            },
                        ])}
                    />
                );
            },
        },
    ];

    return (
        <Box>
            <Table
                rowKey={k => k.id}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                loading={requesting}
                scroll={{ x: 'max-content' }}
            />
        </Box>
    );
};

export default connect(null, {
    cancelOperation,
    deleteOperation,
    startOperationDetailsModal,
    successNotice
})(OperationsListTable);
